import { Button } from 'blaze-ui/Button/Button'
import { DropdownTrigger } from 'components/DropdownTrigger/DropdownTrigger'
import { LocationPicker } from 'components/LocationPicker/LocationPicker'
import { FileIcon } from 'screens/Finder/components/FileIcon/FileIcon'
import { AlmanacFile } from 'types'
import Styles from './LocationFilter.module.scss'
import cx from 'classnames'
import { useEffect } from 'react'

interface Props {
  setFolderFilter: (folder: AlmanacFile) => void
  activeFilter?: AlmanacFile | null
}

export const LocationFilter = ({ setFolderFilter, activeFilter }: Props) => {
  const folder = activeFilter
  const file = {
    database_mode: folder?.database_mode,
    default_view: folder?.default_view,
    header_emoji: folder?.header_emoji,
    type: 'folder',
    isExpanded: false,
  } as any as AlmanacFile

  useEffect(() => {
    if (folder) setFolderFilter(folder)
  }, [folder, setFolderFilter])

  return (
    <DropdownTrigger popoverClassName={Styles.popover}>
      <Button variant="tertiary" withChevron="down" size="lg">
        <div className={cx(Styles.locationPickerButton, { [Styles.folderSet]: !!folder?.id })}>
          {folder?.id ? (
            <>
              <FileIcon file={file} size="md" color="var(--dark-80)" className={Styles.icon} />
              <div className={Styles.folderTitle}>{folder?.title}</div>
            </>
          ) : (
            'All Files'
          )}
        </div>
      </Button>
      {(close) => (
        <LocationPicker
          initialFolder={
            folder
              ? {
                  id: folder.id,
                  title: folder.title,
                  ancestor_keys: folder.ancestor_projects?.map((p) => p.id) || [],
                }
              : null
          }
          actionType="search"
          onSelectFolder={(data) => {
            setFolderFilter(data.selectedFolder as unknown as AlmanacFile)
            close()
          }}
          isRootDisabled
          isCreateDisabled
          hideIcon
        />
      )}
    </DropdownTrigger>
  )
}
